// Port of api/fuel/app/classes/filter/search/games/sorts/post/rating/user/trend.php
import F from 'offline/filter/constants'
import DB from 'offline/db'
import Util from 'offline/util'
import { sorted, sortReverse } from 'offline/filter/core/search/unit'

function getActiveName(filter) {
	if (sorted('rating.up', filter) > 0) return 'rating.up'
	if (sorted('rating.up.absolute', filter) > 0) return 'rating.up.absolute'
	if (sorted('rating.down', filter) > 0) return 'rating.down'
	if (sorted('rating.down.absolute', filter) > 0) return 'rating.down.absolute'
	return null
}

export default {
	name: 'post.sort.rating.user.trend',
	post: true,
	sorts: function() {
		return ['rating.up', 'rating.up.absolute', 'rating.down', 'rating.down.absolute']
	},
	modifies: function() {
		return 'games'
	},
	require: function(config, filter) {
		return config.ownerType === F.OWNER_USER && getActiveName(filter) !== null
	},
	run: function(config, filter, data, results) {
		if (!results.games || !results.games.length) return results

		var name = getActiveName(filter)
		var isUp = name === 'rating.up' || name === 'rating.up.absolute'
		var absolute = name === 'rating.up.absolute' || name === 'rating.down.absolute'
		var rows = DB.query('SELECT game_id, log_rating, log_previous, log_date FROM log_user_rating WHERE game_id IN(' + Util.in(results.games) + ') AND user_id = ' + config.userID + ' ORDER BY log_date DESC')
		var revisions = {}

		for (var i = 0; i < rows.length; i++) {
			var r = rows[i]
			if (!revisions[r.game_id]) revisions[r.game_id] = []
			revisions[r.game_id].push(r)
		}

		var validGames = {}
		var gameIds = Object.keys(revisions)
		for (var g = 0; g < gameIds.length; g++) {
			var gameId = gameIds[g]
			var gameRevisions = revisions[gameId]
			if (gameRevisions.length <= 1) continue

			var latest = gameRevisions[0]
			var earliest = gameRevisions[gameRevisions.length - 1]
			var diff = absolute
				? parseFloat(latest.log_rating || 0) - parseFloat(earliest.log_rating || 0)
				: parseFloat(latest.log_rating || 0) - parseFloat(latest.log_previous || 0)

			if ((isUp && diff > 0) || (!isUp && diff < 0)) {
				validGames[gameId] = Math.abs(diff)
			}
		}

		results.games = results.games.filter(function(gid) { return validGames[gid] !== undefined })
		var reverse = sortReverse(name, filter)
		// Deterministic tiebreaker — matches PHP `trend.php` usort with
		// game_id ASC on equal diffs. Without it, trending top-N diverges
		// for users with many tied rating deltas.
		results.games.sort(function(a, b) {
			var av = validGames[a] || 0
			var bv = validGames[b] || 0
			if (av !== bv) return reverse ? bv - av : av - bv
			return parseInt(a, 10) - parseInt(b, 10)
		})

		var gameOrder = {}
		for (var j = 0; j < results.games.length; j++) gameOrder[results.games[j]] = j
		results.index = results.index.filter(function(id) {
			var gid = results.mapIndex ? results.mapIndex[id] : id
			return validGames[gid] !== undefined
		}).sort(function(a, b) {
			var ga = results.mapIndex ? results.mapIndex[a] : a
			var gb = results.mapIndex ? results.mapIndex[b] : b
			return (gameOrder[ga]||0) - (gameOrder[gb]||0)
		})

		return results
	}
}
